import * as React from 'react';
import './Toggle.scss';


interface Props {
  options: ToggleOption[];
  selectedOption: string;
  onOptionSelected: (option: ToggleOption, index: number) => void;
  itemWidth?: number;
  readOnly?: boolean;
}
export interface ToggleOption {
  value?: string;
  label: string;

}
export class Toggle extends React.Component<Props> {
 
  //   constructor(props:Props) {
  //     super(props)
  //     this.onClick = this.onClick.bind(this)
  //   }
  //   onClick() {
  //     if (this.props.onChange) {
  //       const event = {target:{value:!this.props.on, checked:!this.props.on, type:'checkbox', name:this.props.name }}
  //       // if (this.props.analytics && this.props.analytics.category) {
  //       //   if (!this.props.on &&  this.props.analytics.onAction) {    window.AnalyticsEvent(this.props.analytics.category,  this.props.analytics.onAction);
  //       //   } else if (this.props.on &&  this.props.analytics.offAction) { window.AnalyticsEvent(this.props.analytics.category,  this.props.analytics.offAction); }
  //       // }

  //       this.props.onChange(event)
  //     }
  //   }

  render() {
    // const className = (this.props.on) ? "ssSwitch on": "ssSwitch";
    const itemWidth = this.props.itemWidth || 75;
    const selectedIndex = this.props.options.findIndex(option => option.value === this.props.selectedOption);

    if (this.props.readOnly) {
      let option = this.props.options.find(option => option.value === this.props.selectedOption);
      return <div className="Toggle readOnly"
      style={{ width: `${itemWidth}px` }}

      >
            {option && <div
              key={option.value}
              className={"option" + (option.value === this.props.selectedOption ? " selected" : "")}
              style={{ width: `${itemWidth}px` }}
            >
              {option.label}
            </div>
            }
          
        <div className="background" style={{ width: `${itemWidth}px`, left: 0 }}></div>
      </div>
    }


    return (
      <div className={'Toggle '}
        style={{ width: `${this.props.options.length * itemWidth}px` }}
      >
        {this.props.options.map((option, index) => {
          return (
            <div
              key={index}
              className={"option" + (option.value === this.props.selectedOption ? " selected" : "")}
              style={{ 
                width: `${itemWidth}px`,
                left: `${index * itemWidth}px`
            }}
              onClick={() => this.props.onOptionSelected(option, index)}
            >
              {option.label}
            </div>
          );
        })}
        <div className="background" style={{ width: `${itemWidth}px`, left: `${selectedIndex * itemWidth}px` }}></div>

      </div>
    );
  }
}
